export default function generateURI(uri: string): string {
  return uri;
}
